import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

interface CustomerManager {
    customer_manager_idx: number;
    manager_name: string;
    manager_mobile: string;
    manager_email: string;
}

interface CustomerOptions {
    customer_option_idx: number;
    flag: boolean;
}

export interface GetCustomerResponse {
    customer_idx: number;
    customer_category: number;
    special: boolean;
    customer_name: string;
    customer_post: string;
    customer_address: string;
    customer_address_detail: string;
    current_amount: number;
    status: boolean;
    reg_date: string;
    member_count: number;
    event_content_option: CustomerOptions;
    related_person_option: CustomerOptions;
    work_location_option: CustomerOptions;
    department_option: CustomerOptions;
    union_option: CustomerOptions;
    company_tel_option: CustomerOptions;
    wreath_sender_option: CustomerOptions;
    wreath_word_option: CustomerOptions;
    customer_manager: CustomerManager[];
}
export const useGetCustomerInfo = (customerId: number): UseQueryResult<GetCustomerResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetCustomerResponse, Error>({
        queryKey: ["getCustomerInfo", customerId],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_customer}/${customerId}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        enabled: !!customerId,
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                };
            }
            return undefined;
        },
    });
};
